import { Component } from '@angular/core';

@Component({
  selector: 'app-sed-events-summary',
  templateUrl: './sed-events-summary.component.html',
  styleUrl: './sed-events-summary.component.scss',
  standalone: false,
})
export class SedEventsSummaryComponent {}
